import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { CareersListPage } from '../features/careers/CareersListPage';
import { VacancyInfoPage } from '../features/careers/VacancyInfoPage';
import { VacancyApplyPage } from '../features/careers/VacancyApplyPage';
import { CareersLayout } from '../features/careers/CareersLayout';
import { CareersSignupPage } from '../features/careers/CareersSignupPage';
import { CareersLoginPage } from '../features/careers/CareersLoginPage';
import { LoginPage } from '../features/auth/LoginPage';
import { PartnerRegisterPage } from '../features/auth/PartnerRegisterPage';
import { PartnerVerifyEmailPage } from '../features/auth/PartnerVerifyEmailPage';
import { PartnerForgotPasswordPage } from '../features/auth/PartnerForgotPasswordPage';
import { PartnerResetPasswordPage } from '../features/auth/PartnerResetPasswordPage';
import { PartnerPortalShellPage } from '../features/auth/PartnerPortalShellPage';
import { MyApplicationsPage } from '../features/careers/MyApplicationsPage';
import { MyCandidateProfilePage } from '../features/careers/MyCandidateProfilePage';
import { AppShell } from '../layout/AppShell';
import { DashboardPage } from '../features/dashboard/DashboardPage';
import { UsersPage } from '../features/admin/users/UsersPage';
import { UserDetailPage } from '../features/admin/users/UserDetailPage';
import { DepartmentsPage } from '../features/admin/departments/DepartmentsPage';
import { PositionsPage } from '../features/admin/positions/PositionsPage';
import { LocationsPage } from '../features/admin/locations/LocationsPage';
import { RolesPage } from '../features/admin/roles/RolesPage';
import { RolePermissionsPage } from '../features/admin/roles/RolePermissionsPage';
import { ApprovalMatrixHealthPage } from '../features/admin/ApprovalMatrixHealthPage';
import { PartnerAccountsPage } from '../features/admin/PartnerAccountsPage';
import { DelegationsPage } from '../features/admin/delegations/DelegationsPage';
import { AuditPage } from '../features/admin/audit/AuditPage';
import { ProgrammesPage } from '../features/projects/ProgrammesPage';
import { ProgrammeDetailPage } from '../features/projects/ProgrammeDetailPage';
import { ProjectsPage } from '../features/projects/ProjectsPage';
import { ProjectWorkspaceLayout } from '../features/projects/workspace/ProjectWorkspaceLayout';
import { ProjectOverviewTab } from '../features/projects/workspace/ProjectOverviewTab';
import { ProjectLocationsTab } from '../features/projects/workspace/ProjectLocationsTab';
import { ProjectLogframeTab } from '../features/projects/workspace/ProjectLogframeTab';
import { ProjectWorkplanTab } from '../features/projects/workspace/ProjectWorkplanTab';
import { ProjectBudgetTab } from '../features/projects/workspace/ProjectBudgetTab';
import { ProjectFinanceTab } from '../features/projects/workspace/ProjectFinanceTab';
import { ProjectBeneficiariesTab } from '../features/projects/workspace/ProjectBeneficiariesTab';
import { ProjectImplementationTab } from '../features/projects/workspace/ProjectImplementationTab';
import { ProjectRiskTab } from '../features/projects/workspace/ProjectRiskTab';
import { ProjectMealTab } from '../features/projects/workspace/ProjectMealTab';
import { ProjectTeamTab } from '../features/projects/workspace/ProjectTeamTab';
import { ProjectApprovalsHistoryTab } from '../features/projects/workspace/ProjectApprovalsHistoryTab';
import { ProjectDocumentsTab } from '../features/projects/workspace/ProjectDocumentsTab';
import { ProjectAmendmentsTab } from '../features/projects/workspace/ProjectAmendmentsTab';
import { StaffWorkspaceLayout } from '../features/staff/StaffWorkspaceLayout';
import { StaffDashboardPage } from '../features/staff/StaffDashboardPage';
import { MyProfilePage } from '../features/staff/MyProfilePage';
import { MyIdCardPage } from '../features/staff/MyIdCardPage';
import { MyLeavePage } from '../features/staff/MyLeavePage';
import { MyRequestsPage } from '../features/staff/MyRequestsPage';
import { MyTrainingPage } from '../features/staff/MyTrainingPage';
import { MyPerformancePage } from '../features/staff/MyPerformancePage';
import { MyPayrollPage } from '../features/staff/MyPayrollPage';
import { MyOnboardingPage } from '../features/staff/MyOnboardingPage';
import { MyProbationPage } from '../features/staff/MyProbationPage';
import { MyStaffMovementPage } from '../features/staff/MyStaffMovementPage';
import { MyRestrictedCasesPage } from '../features/staff/MyRestrictedCasesPage';
import { MySeparationPage } from '../features/staff/MySeparationPage';
import { AppraisalDetailPage } from '../features/staff/AppraisalDetailPage';
import { StaffDirectoryPage } from '../features/staff/StaffDirectoryPage';
import { HRWorkspaceLayout } from '../features/hr/HRWorkspaceLayout';
import { HRDashboardPage } from '../features/hr/HRDashboardPage';
import { StaffManagementPage } from '../features/hr/StaffManagementPage';
import { StaffDetailPage } from '../features/hr/StaffDetailPage';
import { VacanciesPage } from '../features/hr/VacanciesPage';
import { WorkforceRequestsPage } from '../features/hr/WorkforceRequestsPage';
import { VacancyDetailPage } from '../features/hr/VacancyDetailPage';
import { ContractTemplatesPage } from '../features/hr/ContractTemplatesPage';
import { LeaveReviewPage } from '../features/hr/LeaveReviewPage';
import { HrRequestsPage } from '../features/hr/HrRequestsPage';
import { TrainingReviewPage } from '../features/hr/TrainingReviewPage';
import { PerformancePage } from '../features/hr/PerformancePage';
import { PayrollPage } from '../features/hr/PayrollPage';
import { OnboardingPage } from '../features/hr/OnboardingPage';
import { ProbationPage } from '../features/hr/ProbationPage';
import { StaffMovementPage } from '../features/hr/StaffMovementPage';
import { RestrictedCasesPage } from '../features/hr/RestrictedCasesPage';
import { SeparationPage } from '../features/hr/SeparationPage';
import { FinanceDashboardPage } from '../features/finance/FinanceDashboardPage';
import { ChartOfAccountsPage } from '../features/finance/ChartOfAccountsPage';
import { FiscalYearsPage } from '../features/finance/FiscalYearsPage';
import { CostCentresPage } from '../features/finance/CostCentresPage';
import { FundingSourcesPage } from '../features/finance/FundingSourcesPage';
import { GrantsPage } from '../features/finance/GrantsPage';
import { BudgetsPage } from '../features/finance/BudgetsPage';
import { FinanceSettingsPage } from '../features/finance/FinanceSettingsPage';
import { JournalEntriesPage } from '../features/finance/JournalEntriesPage';
import { IncomeRecordsPage } from '../features/finance/IncomeRecordsPage';
import { BankAccountsPage } from '../features/finance/BankAccountsPage';
import { ProjectsFinanceSummaryPage } from '../features/finance/ProjectsFinanceSummaryPage';
import { ReportsPage } from '../features/finance/ReportsPage';
import { JournalEntryDetailPage } from '../features/finance/JournalEntryDetailPage';
import { GeneralLedgerPage } from '../features/finance/GeneralLedgerPage';
import { TrialBalancePage } from '../features/finance/TrialBalancePage';
import { ExpenseClaimsPage } from '../features/finance/ExpenseClaimsPage';
import { PayablesPage } from '../features/finance/PayablesPage';
import { ReceivablesPage } from '../features/finance/ReceivablesPage';

// Future modules (Partners, Vendors, Procurement, Finance, Payments,
// HR, MEAL, Documents, Workflows, Notifications, Reporting) each
// become a new top-level child route here, following the same
// pattern - no restructuring needed when they're built.
const router = createBrowserRouter([
  // Genuinely public - a real sibling to the authenticated AppShell
  // tree below, not nested inside it, so it never depends on any
  // Entra session and is reachable by anyone with the link.
  {
    path: '/careers',
    element: <CareersLayout />,
    children: [
      { index: true, element: <CareersListPage /> },
      { path: 'vacancies/:id', element: <VacancyInfoPage /> },
      { path: 'vacancies/:id/apply', element: <VacancyApplyPage /> },
      { path: 'signup', element: <CareersSignupPage /> },
      { path: 'login', element: <CareersLoginPage /> },
      { path: 'my-applications', element: <MyApplicationsPage /> },
      { path: 'my-profile', element: <MyCandidateProfilePage /> },
    ],
  },
  // The new branded email-first login page and the Partner Portal
  // pages - equally public, equally must never sit under AppShell
  // (which assumes an authenticated Entra session).
  { path: '/login', element: <LoginPage /> },
  { path: '/partner/register', element: <PartnerRegisterPage /> },
  { path: '/partner/verify-email', element: <PartnerVerifyEmailPage /> },
  { path: '/partner/forgot-password', element: <PartnerForgotPasswordPage /> },
  { path: '/partner/reset-password', element: <PartnerResetPasswordPage /> },
  { path: '/partner/portal', element: <PartnerPortalShellPage /> },
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'dashboard', element: <Navigate to="/" replace /> },
      { path: 'programmes', element: <ProgrammesPage /> },
      { path: 'programmes/:programmeId', element: <ProgrammeDetailPage /> },
      {
        path: 'staff',
        element: <StaffWorkspaceLayout />,
        children: [
          { index: true, element: <StaffDashboardPage /> },
          { path: 'profile', element: <MyProfilePage /> },
          { path: 'id-card', element: <MyIdCardPage /> },
          { path: 'leave', element: <MyLeavePage /> },
          { path: 'requests', element: <MyRequestsPage /> },
          { path: 'training', element: <MyTrainingPage /> },
          { path: 'performance', element: <MyPerformancePage /> },
          { path: 'payroll', element: <MyPayrollPage /> },
          { path: 'onboarding', element: <MyOnboardingPage /> },
          { path: 'probation', element: <MyProbationPage /> },
          { path: 'movement', element: <MyStaffMovementPage /> },
          { path: 'restricted-cases', element: <MyRestrictedCasesPage /> },
          { path: 'separation', element: <MySeparationPage /> },
          { path: 'performance/:appraisalId', element: <AppraisalDetailPage /> },
          { path: 'directory', element: <StaffDirectoryPage /> },
        ],
      },
      {
        path: 'hr',
        element: <HRWorkspaceLayout />,
        children: [
          { index: true, element: <HRDashboardPage /> },
          { path: 'staff', element: <StaffManagementPage /> },
          { path: 'vacancies', element: <VacanciesPage /> },
          { path: 'workforce-requests', element: <WorkforceRequestsPage /> },
          { path: 'contract-templates', element: <ContractTemplatesPage /> },
          { path: 'leave-review', element: <LeaveReviewPage /> },
          { path: 'requests', element: <HrRequestsPage /> },
          { path: 'training-review', element: <TrainingReviewPage /> },
          { path: 'performance', element: <PerformancePage /> },
          { path: 'payroll', element: <PayrollPage /> },
          { path: 'onboarding', element: <OnboardingPage /> },
          { path: 'probation', element: <ProbationPage /> },
          { path: 'staff-movement', element: <StaffMovementPage /> },
          { path: 'restricted-cases', element: <RestrictedCasesPage /> },
          { path: 'separation', element: <SeparationPage /> },
        ],
      },
      { path: 'hr/staff/:employeeId', element: <StaffDetailPage /> },
      { path: 'hr/vacancies/:vacancyId', element: <VacancyDetailPage /> },
      { path: 'projects', element: <ProjectsPage /> },
      {
        path: 'projects/:projectId',
        element: <ProjectWorkspaceLayout />,
        children: [
          { index: true, element: <Navigate to="overview" replace /> },
          { path: 'overview', element: <ProjectOverviewTab /> },
          { path: 'locations', element: <ProjectLocationsTab /> },
          { path: 'logical-framework', element: <ProjectLogframeTab /> },
          { path: 'workplan', element: <ProjectWorkplanTab /> },
          { path: 'budget', element: <ProjectBudgetTab /> },
          { path: 'finance', element: <ProjectFinanceTab /> },
          { path: 'beneficiaries', element: <ProjectBeneficiariesTab /> },
          { path: 'implementation', element: <ProjectImplementationTab /> },
          { path: 'risk', element: <ProjectRiskTab /> },
          { path: 'meal', element: <ProjectMealTab /> },
          { path: 'team', element: <ProjectTeamTab /> },
          { path: 'approvals', element: <ProjectApprovalsHistoryTab /> },
          { path: 'documents', element: <ProjectDocumentsTab /> },
          { path: 'amendments', element: <ProjectAmendmentsTab /> },
        ],
      },
      { path: 'finance', element: <FinanceDashboardPage /> },
      { path: 'finance/accounts', element: <ChartOfAccountsPage /> },
      { path: 'finance/fiscal-years', element: <FiscalYearsPage /> },
      { path: 'finance/cost-centres', element: <CostCentresPage /> },
      { path: 'finance/funding-sources', element: <FundingSourcesPage /> },
      { path: 'finance/grants', element: <GrantsPage /> },
      { path: 'finance/budgets', element: <BudgetsPage /> },
      { path: 'finance/settings', element: <FinanceSettingsPage /> },
      { path: 'finance/journal-entries', element: <JournalEntriesPage /> },
      { path: 'finance/journal-entries/:id', element: <JournalEntryDetailPage /> },
      { path: 'finance/general-ledger', element: <GeneralLedgerPage /> },
      { path: 'finance/trial-balance', element: <TrialBalancePage /> },
      { path: 'finance/expenses', element: <ExpenseClaimsPage /> },
      { path: 'finance/income', element: <IncomeRecordsPage /> },
      { path: 'finance/payables', element: <PayablesPage /> },
      { path: 'finance/receivables', element: <ReceivablesPage /> },
      { path: 'finance/bank-cash', element: <BankAccountsPage /> },
      { path: 'finance/projects-finance', element: <ProjectsFinanceSummaryPage /> },
      { path: 'finance/reports', element: <ReportsPage /> },
      { path: 'admin/users', element: <UsersPage /> },
      { path: 'admin/users/:userId', element: <UserDetailPage /> },
      { path: 'admin/departments', element: <DepartmentsPage /> },
      { path: 'admin/positions', element: <PositionsPage /> },
      { path: 'admin/locations', element: <LocationsPage /> },
      { path: 'admin/roles', element: <RolesPage /> },
      { path: 'admin/roles/:roleId/permissions', element: <RolePermissionsPage /> },
      { path: 'admin/approval-matrix-health', element: <ApprovalMatrixHealthPage /> },
      { path: 'admin/partner-accounts', element: <PartnerAccountsPage /> },
      { path: 'admin/delegations', element: <DelegationsPage /> },
      { path: 'admin/audit', element: <AuditPage /> },
    ],
  },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
